import {
  CasEntityRHFSelect,
  CasEntitySelect,
  componentProps,
  CasEntitySelectProps,
} from 'src/compass/shared/components';

const entity = "Cme/AccountSources/Select";

export function CasRHFSourceSelect(props: CasEntitySelectProps) {
  return CasEntityRHFSelect(entity, props);
}

export function CasSourceSelect(props: componentProps) {
  return CasEntitySelect(entity, props);
}
